(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/start-game-by-loader.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/start-game-by-loader.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _ref = svs.ticketUtility && svs.ticketUtility.data.gameloaderHelperConfig || {},
  hostKey = _ref.hostKey,
  lotteryCode = _ref.lotteryCode,
  itf = _ref.itf,
  neo = _ref.neo,
  url = _ref.url;
const hasNativeBridge = () => {
  var _window$webkit;
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean((_window$webkit = window.webkit) === null || _window$webkit === void 0 ? void 0 : _window$webkit.messageHandlers);
};
const isGyroSupported = () => {
  var _window;
  if (hasNativeBridge()) {
    return true;
  }
  const orientationEvent = (_window = window) === null || _window === void 0 ? void 0 : _window.DeviceOrientationEvent;
  if (!orientationEvent) {
    return false;
  }

  if (typeof orientationEvent.requestPermission === 'function') {
    return false;
  }
  return true;
};
const getFeatureParameters = () => {
  if (hasNativeBridge()) {
    return {};
  }
  let featureParameters = {
    scratchVibration: {
      active: Boolean(navigator.vibrate),
      data: {
        minMovePx: 10,
        interval: [4, 16, 4, 16, 2, 8] 
      }
    },
    scratchVibrationSpeed: {
      active: false
    }
  };
  if (!isGyroSupported()) {
    featureParameters = _objectSpread(_objectSpread({}, featureParameters), {}, {
      scratchParticleCollision: {
        active: false
      },
      gyroParticles: {
        active: false
      }
    });
  }
  return {
    feature: featureParameters
  };
};
const applyNextGenFeatureGameSpecificParameters = (gameSpecificParameters, type) => {
  const gameTypesWithNextGenFeature = ['svstriss30campaign50y26w11', 'svstriss100campaign50y26w32'];
  if (gameTypesWithNextGenFeature.includes(type)) {
    return _objectSpread(_objectSpread({}, gameSpecificParameters), getFeatureParameters());
  }
  return gameSpecificParameters;
};
const getFGSBridgeParameters = _ref2 => {
  var _gameSpecificParamete;
  let gameSpecificParameters = _ref2.gameSpecificParameters,
    gameContext = _ref2.gameContext,
    soundEnabled = _ref2.soundEnabled;
  const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.constants.leia.lotteryChannel,
    WEB = _svs$ticketgames$tick.WEB,
    VOUCHER = _svs$ticketgames$tick.VOUCHER;
  const _gameContext$ticketIn = gameContext.ticketInfo,
    gameLoader = _gameContext$ticketIn.gameLoader,
    theme = _gameContext$ticketIn.theme,
    type = _gameContext$ticketIn.type,
    isDemo = gameContext.isDemo,
    _gameContext$betId = gameContext.betId,
    betId = _gameContext$betId === void 0 ? undefined : _gameContext$betId,
    _gameContext$voucherC = gameContext.voucherCode,
    voucherCode = _gameContext$voucherC === void 0 ? null : _gameContext$voucherC,
    _gameContext$isEInsta = gameContext.isEInstant,
    isEInstant = _gameContext$isEInsta === void 0 ? false : _gameContext$isEInsta;
  const lotteryChannel = svs.ticketgames.ticketMappings.channelMappings.getChannel(voucherCode ? VOUCHER : WEB, svs.core.data.capabilities.channel);
  if ((_gameSpecificParamete = gameSpecificParameters) !== null && _gameSpecificParamete !== void 0 && _gameSpecificParamete.skinId) {
    gameSpecificParameters = _objectSpread(_objectSpread({}, gameSpecificParameters), {}, {
      skinId: svs.ticketgames.ticketUtility.utils.normalizeSkinId(gameSpecificParameters.skinId)
    });
  }
  gameSpecificParameters = applyNextGenFeatureGameSpecificParameters(gameSpecificParameters, type);
  return {
    crossDomain: {
      hostKey,
      authorizedHosts: [window.location.host]
    },
    gameloader: {
      url: itf === null || itf === void 0 ? void 0 : itf.url,
      name: gameLoader,
      betId,
      gameMode: isDemo ? 'DEMO' : 'NORMAL',
      lotteryChannel,
      gameSpecificParameters: _objectSpread(_objectSpread({}, gameSpecificParameters), {}, {
        lockProgress: svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)
      }),
      theme: isEInstant ? null : theme,
      soundEnabled
    }
  };
};
const getNEORgsParameters = async _ref3 => {
  let gameContext = _ref3.gameContext,
    soundEnabled = _ref3.soundEnabled;
  const WEB = svs.ticketgames.ticketUtility.utils.constants.leia.lotteryChannel.WEB;
  const NEO = svs.ticketgames.ticketUtility.utils.constants.leia.gameEngineCode.NEO;
  const lotteryChannel = svs.ticketgames.ticketMappings.channelMappings.getChannel(WEB, svs.core.data.capabilities.channel);
  const _gameContext$ticketIn2 = gameContext.ticketInfo,
    gameLoader = _gameContext$ticketIn2.gameLoader,
    GameCode = _gameContext$ticketIn2.type,
    IsDemoMode = gameContext.isDemo,
    betId = gameContext.betId;
  return {
    crossDomain: {
      hostKey,
      authorizedHosts: [window.location.host]
    },
    gameloader: {
      url: neo === null || neo === void 0 ? void 0 : neo.url,
      name: gameLoader,
      betId,
      gameMode: IsDemoMode ? 'DEMO' : 'NORMAL',
      lotteryChannel,
      lotteryCode,
      soundEnabled,
      engineCode: NEO,
      engineType: 'RGS',
      servicesBaseUrl: url,
      gameSpecificParameters: {
        IsDemoMode,
        GameCode,
        CurrencyCode: 'SEK',
        LanguageCode: 'sv-SE',
        CountryCode: 'SE',
        LotteryCode: lotteryCode,
        HomeUrl: '',
        CashierUrl: ''
      }
    }
  };
};
setGlobal('svs.ticketgames.ticketUtility.components.startGameByLoader', _ref4 => {
  var _gameContext$ticketIn3, _svs$ticketgames$tick3;
  let gameSpecificParameters = _ref4.gameSpecificParameters,
    gameContext = _ref4.gameContext,
    soundEnabled = _ref4.soundEnabled,
    onDone = _ref4.onDone;
  const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils.constants.leia.GAME_LOADERS,
    FGS_BRIDGE = _svs$ticketgames$tick2.FGS_BRIDGE,
    NEO_RGS = _svs$ticketgames$tick2.NEO_RGS;
  const gameLoader = (_gameContext$ticketIn3 = gameContext.ticketInfo) === null || _gameContext$ticketIn3 === void 0 ? void 0 : _gameContext$ticketIn3.gameLoader.toUpperCase();
  (_svs$ticketgames$tick3 = svs.ticketgames.ticketUtility) === null || _svs$ticketgames$tick3 === void 0 || _svs$ticketgames$tick3.loadGameloaderHelper.then(() => {
    switch (gameLoader) {
      case FGS_BRIDGE:
        onDone(getFGSBridgeParameters({
          gameSpecificParameters,
          gameContext,
          soundEnabled
        }));
        return;
      case NEO_RGS:
        getNEORgsParameters({
          gameContext,
          soundEnabled
        }).then(onDone);
        return;
      default:
        throw new Error("Unsupported gameLoader: ".concat(gameLoader));
    }
  });
});

 })(window);